<div class="flex flex-col min-h-full">
  <l-list-header
    title="Criação de usuários"
    subtitle="Gerencia a criação e atualização de usuários"
  />

  <l-crud-container [formGroup]="form">
    <div class="grid gap-5 grid-cols-12">
      <div class="flex gap-2 col-span-12">
        <button lButton bType="primary" (click)="test()">Request</button>
        <button lButton bType="danger" (click)="cancel()">Cancel Request</button>
      </div>

      <div class="col-span-12">
          <label class="text-sm subtext-color" for="user-crud-select">Teste de select</label>
        <l-select
            id="user-crud-select"
          placeholder="Selecionar usuários"
          key="id"
          showKey="name"
          [search]="false"
          [multiple]="true"
          [modal]="false"
          [data]="[{id: 1, name: 'Teste 1'}, {id: 2, name: 'Teste 2'}]"
        />
      </div>

      <div class="col-span-12">
          <label class="text-sm subtext-color" for="user-crud-name">Nome</label>

        <div class="flex gap-4 mt-2">
            <input id="user-crud-name" class="flex-1" [class.!border-lDanger]="validation.name.invalid" formControlName="name" lInput placeholder="Nome">
          <button class="w-max" lButton (click)="addRole()">Nova permissão</button>
        </div>

        <small class="text-lDanger font-bold" *ngFor="let error of validation.name.errors">
          {{ error }}
        </small>
      </div>

      <div formArrayName="roles" class="col-span-12 border-2 p-4 border-radius">
        <h6 class="text-color mb-4">Permissões</h6>
        <div *ngFor="let roleGroup of form.controls.roles.controls; let i = index"
             [formGroupName]="i"
             class="mb-2 w-full"
        >
          <input lInput formControlName="permission"/>

          <small class="text-lDanger font-bold" *ngFor="let error of validation.roles[i].permission.errors">
            {{ error }}
          </small>
        </div>
      </div>
    </div>

    <div class="flex justify-end w-full mt-auto pt-5 gap-5">
      <button class="w-min" lButton (click)="return()">
        Cancelar
      </button>

      <button (click)="submit()" [pTooltip]="globalError || ''" class="w-min" lButton bType="primary">
        Salvar
      </button>
    </div>
  </l-crud-container>
</div>
